(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4266],{

/***/ 77957:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), 'Edit');
exports.Z = _default;

/***/ }),

/***/ 50891:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
}), 'Email');
exports.Z = _default;

/***/ }),

/***/ 69308:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
}), 'LocationOn');
exports.Z = _default;

/***/ }),

/***/ 82770:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M16 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4.78 3.58C19.93 7.21 18.99 7 18 7c-.67 0-1.31.1-1.92.28.58.55.92 1.32.92 2.15V10h5v-.57c0-.81-.48-1.53-1.22-1.85zM6 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.92 1.28C7.31 7.1 6.67 7 6 7c-.99 0-1.93.21-2.78.58C2.48 7.9 2 8.62 2 9.43V10h5v-.57c0-.83.34-1.6.92-2.15zM10 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6H8v-.57c0-.81.48-1.53 1.22-1.85C10.07 7.21 11.01 7 12 7c.99 0 1.93.21 2.78.58.74.32 1.22 1.04 1.22 1.85V10zm-1 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6h-8v-.57c0-.81.48-1.53 1.22-1.85.85-.37 1.79-.58 2.78-.58.99 0 1.93.21 2.78.58.74.32 1.22 1.04 1.22 1.85V22zM5 16c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6H3v-.57c0-.81.48-1.53 1.22-1.85C5.07 19.21 6.01 19 7 19c.99 0 1.93.21 2.78.58.74.32 1.22 1.04 1.22 1.85V22zm1.75-9v-2h-1.5v2H9l3 3 3-3h-2.25z"
}), 'ReduceCapacity');
exports.Z = _default;

/***/ }),

/***/ 42176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ GridToolbarContainer; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28714);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94780);
/* harmony import */ var _constants_gridClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73490);
/* harmony import */ var _hooks_utils_useGridRootProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48836);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


const _excluded = ["className", "children"];









const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['toolbarContainer']
  };
  return (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(slots, _constants_gridClasses__WEBPACK_IMPORTED_MODULE_3__/* .getDataGridUtilityClass */ .d, classes);
};

const GridToolbarContainerRoot = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)('div', {
  name: 'MuiDataGrid',
  slot: 'ToolbarContainer',
  overridesResolver: (props, styles) => styles.toolbarContainer
})(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  padding: theme.spacing(0.5, 0.5, 0)
}));
const GridToolbarContainer = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function GridToolbarContainer(props, ref) {
  const {
    className,
    children
  } = props,
        other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, _excluded);

  const rootProps = (0,_hooks_utils_useGridRootProps__WEBPACK_IMPORTED_MODULE_6__/* .useGridRootProps */ .B)();
  const classes = useUtilityClasses(rootProps);

  if (!children) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GridToolbarContainerRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    ref: ref,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(className, classes.root),
    ownerState: rootProps
  }, other, {
    children: children
  }));
});
 false ? 0 : void 0;


/***/ }),

/***/ 23370:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(()=>{return t={705:t=>{t.exports=function(t,e){const h=[];return 0===e.length?h.push({text:t,highlight:!1}):e[0][0]>0&&h.push({text:t.slice(0,e[0][0]),highlight:!1}),e.forEach(((i,o)=>{const s=i[0],r=i[1];h.push({text:t.slice(s,r),highlight:!0}),o===e.length-1?r<t.length&&h.push({text:t.slice(r,t.length),highlight:!1}):r<e[o+1][0]&&h.push({text:t.slice(r,e[o+1][0]),highlight:!1})})),h}}},e={},function h(i){var o=e[i];if(void 0!==o)return o.exports;var s=e[i]={exports:{}};return t[i](s,s.exports,h),s.exports}(705);var t,e}));

/***/ }),

/***/ 11752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(62156)


/***/ }),

/***/ 44414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GoogleMapsAutoComplete; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27812);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68239);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22430);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50135);
/* harmony import */ var _mui_material_Autocomplete__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23776);
/* harmony import */ var _mui_icons_material_LocationOn__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69308);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86886);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15861);
/* harmony import */ var autosuggest_highlight_parse__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23370);
/* harmony import */ var autosuggest_highlight_parse__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(autosuggest_highlight_parse__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94054);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(56815);
/* harmony import */ var _TextField_TextField__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14491);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















function loadScript(src, position, id) {
  if (!position) {
    return;
  }

  var script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}

var autocompleteService = {
  current: null
};
function GoogleMapsAutoComplete(props) {
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(props.value ? props.value : null),
      _React$useState2 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_1__.useState(''),
      _React$useState4 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_React$useState3, 2),
      inputValue = _React$useState4[0],
      setInputValue = _React$useState4[1];

  var _React$useState5 = react__WEBPACK_IMPORTED_MODULE_1__.useState([]),
      _React$useState6 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_React$useState5, 2),
      options = _React$useState6[0],
      setOptions = _React$useState6[1];

  var loaded = react__WEBPACK_IMPORTED_MODULE_1__.useRef(false);
  var darkTheme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    palette: {
      mode: 'dark'
    }
  });
  var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(); // added hardcoded api key to attempt to fix dev/test deploys
  // TODO: remove and get new token once network issue resolved

  var googleApiKeyHC = "AIzaSyAApCIYwA9Xuu10bjI-AN-hRAcgeH3Ef_M";

  if ( true && !loaded.current) {
    if (!document.querySelector('#google-maps')) {
      loadScript("https://maps.googleapis.com/maps/api/js?key=".concat(googleApiKeyHC, "&libraries=places"), document.querySelector('head'), 'google-maps');
    }

    loaded.current = true;
  }

  var fetch = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function () {
    return (0,_mui_material_utils__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function (request, callback) {
      autocompleteService.current.getPlacePredictions(request, callback);
    }, 400);
  }, []);
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function () {
    var active = true;

    if (!autocompleteService.current && window.google) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
    }

    if (!autocompleteService.current) {
      return undefined;
    }

    if (inputValue === '') {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch({
      input: inputValue
    }, function (results) {
      if (active) {
        var newOptions = [];

        if (value) {
          newOptions = [value];
        }

        if (results) {
          newOptions = [].concat((0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(newOptions), (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(results));
        }

        setOptions(newOptions);
      }
    });
    return function () {
      active = false;
    };
  }, [value, inputValue, fetch]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    theme: props.newUIUXStyle ? darkTheme : theme,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      fullWidth: true,
      error: props.error ? true : false,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material_Autocomplete__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        id: props.id,
        getOptionLabel: function getOptionLabel(option) {
          return typeof option === 'string' ? option : option.description;
        },
        filterOptions: function filterOptions(x) {
          return x;
        },
        options: options,
        autoComplete: true,
        includeInputInList: true,
        filterSelectedOptions: true,
        value: value,
        noOptionsText: "No locations",
        onChange: function onChange(event, newValue) {
          setOptions(newValue ? [newValue].concat((0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(options)) : options);
          setValue(newValue);
          if (props.onChange) props.onChange(newValue);
        },
        onInputChange: function onInputChange(event, newInputValue) {
          setInputValue(newInputValue);
        },
        onBlur: function onBlur() {
          if (props.onBlur) props.onBlur();
        },
        renderInput: function renderInput(params) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
            children: props.newUIUXStyle ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* .TextField */ .n, _objectSpread(_objectSpread({}, params), {}, {
              size: "md",
              placeholder: "Start typing address",
              fullWidth: true,
              error: props.error ? true : false
            })) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, params), {}, {
              label: "Venue Street Address",
              fullWidth: true,
              error: props.error ? true : false
            }))
          });
        },
        renderOption: function renderOption(props, option) {
          var matches = option.structured_formatting.main_text_matched_substrings || [];
          var parts = autosuggest_highlight_parse__WEBPACK_IMPORTED_MODULE_2___default()(option.structured_formatting.main_text, matches.map(function (match) {
            return [match.offset, match.offset + match.length];
          }));
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("li", _objectSpread(_objectSpread({}, props), {}, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
              container: true,
              alignItems: "center",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                item: true,
                sx: {
                  display: 'flex',
                  width: 44
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_icons_material_LocationOn__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                  sx: {
                    color: 'text.secondary'
                  }
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                item: true,
                sx: {
                  width: 'calc(100% - 44px)',
                  wordWrap: 'break-word'
                },
                children: [parts.map(function (part, index) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    component: "span",
                    sx: {
                      fontWeight: part.highlight ? 'bold' : 'regular'
                    },
                    children: part.text
                  }, index);
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                  variant: "body2",
                  color: "text.secondary",
                  children: option.structured_formatting.secondary_text
                })]
              })]
            })
          }));
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        children: props.helperText
      })]
    })
  });
}

/***/ }),

/***/ 44266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pages_Show_Show; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/pages/Show/Show.module.scss
var Show_module = __webpack_require__(62185);
var Show_module_default = /*#__PURE__*/__webpack_require__.n(Show_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/x-data-grid/DataGrid/DataGrid.js + 194 modules
var DataGrid = __webpack_require__(70187);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(21023);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(64666);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(37645);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContentText/DialogContentText.js + 1 modules
var DialogContentText = __webpack_require__(58951);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 1 modules
var InputLabel = __webpack_require__(47312);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 4 modules
var Select = __webpack_require__(18360);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(31425);
// EXTERNAL MODULE: ./node_modules/@mui/material/Snackbar/Snackbar.js + 4 modules
var Snackbar = __webpack_require__(14354);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 5 modules
var Alert = __webpack_require__(46901);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Edit.js
var Edit = __webpack_require__(77957);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Email.js
var Email = __webpack_require__(50891);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ReduceCapacity.js
var ReduceCapacity = __webpack_require__(82770);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Add.js
var Add = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Delete.js
var Delete = __webpack_require__(46761);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/services/ShowService.tsx
var ShowService = __webpack_require__(90774);
// EXTERNAL MODULE: ./src/components/Page/Page.tsx
var Page = __webpack_require__(96204);
// EXTERNAL MODULE: ./src/components/HealthScoreBar/HealthScoreBar.tsx
var HealthScoreBar = __webpack_require__(98886);
// EXTERNAL MODULE: ./node_modules/@mui/x-data-grid/components/containers/GridToolbarContainer.js
var GridToolbarContainer = __webpack_require__(42176);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ShowsCustomTableToolbar/ShowsCustomTableToolbar.tsx






var ShowsCustomTableToolbar = function ShowsCustomTableToolbar(_ref) {
  var companyHealthScore = _ref.companyHealthScore;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(GridToolbarContainer/* GridToolbarContainer */.D, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 2,
        px: 1,
        borderBottom: 1,
        borderColor: "#E0E0E0"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          variant: "caption",
          align: "center",
          children: "Company Health Score"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          sx: {
            px: "16px",
            pt: .5,
            width: 160
          },
          "data-cy": "company-healthscore",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(HealthScoreBar/* default */.Z, {
            score: companyHealthScore,
            childType: "shows"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var ShowsCustomTableToolbar_ShowsCustomTableToolbar = (ShowsCustomTableToolbar);
// EXTERNAL MODULE: ./src/pages/Show/CreateShow/CreateShow.module.scss
var CreateShow_module = __webpack_require__(38213);
var CreateShow_module_default = /*#__PURE__*/__webpack_require__.n(CreateShow_module);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Add.js
var esm_Add = __webpack_require__(72428);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Remove.js
var Remove = __webpack_require__(38679);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(50135);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormLabel/FormLabel.js
var FormLabel = __webpack_require__(40476);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fab/Fab.js + 1 modules
var Fab = __webpack_require__(58032);
;// CONCATENATED MODULE: ./src/models/createShow/Show.tsx



var Show = /*#__PURE__*/(0,createClass/* default */.Z)( //TODO Replace dummy test data with real input fields when refactoring the create module
function Show() {
  (0,classCallCheck/* default */.Z)(this, Show);

  (0,defineProperty/* default */.Z)(this, "name", void 0);

  (0,defineProperty/* default */.Z)(this, "networkName", void 0);

  (0,defineProperty/* default */.Z)(this, "productionCompany", void 0);

  (0,defineProperty/* default */.Z)(this, "publicRouteUrL", void 0);

  (0,defineProperty/* default */.Z)(this, "termsAndConditions", void 0);

  (0,defineProperty/* default */.Z)(this, "defaultTicketingStartTimeOffsetTicks", void 0);

  this.name = '';
  this.networkName = 'test';
  this.productionCompany = 'test';
  this.publicRouteUrL = 'test';
  this.termsAndConditions = 'test';
  this.defaultTicketingStartTimeOffsetTicks = 0;
});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/auth.tsx
var auth = __webpack_require__(22877);
;// CONCATENATED MODULE: ./src/services/ImageService.tsx



var readImage = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(imageId) {
    var url, res, message;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            url = "/api/backend/images?id=".concat(imageId);
            _context.next = 4;
            return (0,auth/* defaultFetch */.zo)(url);

          case 4:
            res = _context.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context.next = 7;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 7:
            return _context.abrupt("return", res);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);

            if (_context.t0 instanceof Error) {
              message = _context.t0.message;
            } else {
              message = 'Unable to fetch image';
            }

            return _context.abrupt("return", {
              error: message
            });

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));

  return function readImage(_x) {
    return _ref.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./enums/ShowTemplates.tsx


var _ShowTemplateTypeName;

var ShowTemplateType;

(function (ShowTemplateType) {
  ShowTemplateType["FirstEmailTemplate"] = "FirstEmailTemplate";
  ShowTemplateType["ReminderEmailTemplate"] = "ReminderEmailTemplate";
  ShowTemplateType["ConfirmEmailTemplate"] = "ConfirmEmailTemplate";
  ShowTemplateType["GroupEmailTemplate"] = "GroupEmailTemplate";
  ShowTemplateType["TicketEmailTemplate"] = "TicketEmailTemplate";
  ShowTemplateType["ConfirmSmsTemplate"] = "ConfirmSmsTemplate";
  ShowTemplateType["ReminderSmsTemplate"] = "ReminderSmsTemplate";
})(ShowTemplateType || (ShowTemplateType = {}));

var ShowTemplateTypeNames = (_ShowTemplateTypeName = {}, (0,defineProperty/* default */.Z)(_ShowTemplateTypeName, ShowTemplateType.FirstEmailTemplate, "First Email Template"), (0,defineProperty/* default */.Z)(_ShowTemplateTypeName, ShowTemplateType.ReminderEmailTemplate, "Reminder Email Template"), (0,defineProperty/* default */.Z)(_ShowTemplateTypeName, ShowTemplateType.ConfirmEmailTemplate, "Confirmation Email Template"), (0,defineProperty/* default */.Z)(_ShowTemplateTypeName, ShowTemplateType.GroupEmailTemplate, "Group Email Template"), (0,defineProperty/* default */.Z)(_ShowTemplateTypeName, ShowTemplateType.TicketEmailTemplate, "Ticket Email Template"), (0,defineProperty/* default */.Z)(_ShowTemplateTypeName, ShowTemplateType.ConfirmSmsTemplate, "Confirmation SMS Template"), (0,defineProperty/* default */.Z)(_ShowTemplateTypeName, ShowTemplateType.ReminderSmsTemplate, "Reminder SMS Template"), _ShowTemplateTypeName);
;// CONCATENATED MODULE: ./src/models/Template.ts
var emptyInputContentVariable = {
  header: "",
  title: "",
  description: ["", ""],
  news: "",
  upperCaseText: "",
  boldUpperCaseText: "",
  hypePhrase: ""
};
// EXTERNAL MODULE: ./src/pages/Show/CreateShow/TemplateInput/TemplateInput.module.scss
var TemplateInput_module = __webpack_require__(95002);
var TemplateInput_module_default = /*#__PURE__*/__webpack_require__.n(TemplateInput_module);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/StyledEngineProvider/StyledEngineProvider.js
var StyledEngineProvider = __webpack_require__(94810);
;// CONCATENATED MODULE: ./src/pages/Show/CreateShow/TemplateInput/TemplateInput.tsx







var TemplateInput = function TemplateInput(props) {
  var _props$templates2, _props$templates3, _props$templates3$fin;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledEngineProvider/* default */.Z, {
    injectFirst: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
      fullWidth: true,
      className: (TemplateInput_module_default()).input,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
        children: props.name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* default */.Z, {
        value: props.template,
        label: props.name,
        onChange: function onChange(event) {
          var _props$templates, _props$templates$find;

          props.setTemplate(event.target.value);

          if (!((_props$templates = props.templates) !== null && _props$templates !== void 0 && (_props$templates$find = _props$templates.find(function (t) {
            return t.name == event.target.value;
          })) !== null && _props$templates$find !== void 0 && _props$templates$find.hasInputContentVariables)) {
            props.setTemplateSubject("");
            props.setTemplateContent(props.emptyContentJson);
          }
        },
        children: (_props$templates2 = props.templates) === null || _props$templates2 === void 0 ? void 0 : _props$templates2.filter(function (template) {
          return template.notificationType == props.mailType;
        }).map(function (template, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
            value: template.name,
            children: template.name
          }, index);
        })
      })]
    }), ((_props$templates3 = props.templates) === null || _props$templates3 === void 0 ? void 0 : (_props$templates3$fin = _props$templates3.find(function (t) {
      return t.name == props.template;
    })) === null || _props$templates3$fin === void 0 ? void 0 : _props$templates3$fin.hasInputContentVariables) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
        className: (TemplateInput_module_default()).input,
        label: "Subject",
        required: true,
        size: "small",
        value: props.templateSubject,
        onChange: function onChange(event) {
          props.setTemplateSubject(event.target.value);
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
        className: (TemplateInput_module_default()).input,
        label: "Content",
        required: true,
        multiline: true,
        size: "small",
        value: props.templateContent,
        onChange: function onChange(event) {
          props.setTemplateContent(event.target.value);
        }
      })]
    })]
  });
};

/* harmony default export */ var TemplateInput_TemplateInput = (TemplateInput);
// EXTERNAL MODULE: ./src/utils/dates.tsx
var dates = __webpack_require__(15443);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/pages/Show/CreateShow/ShootingLocationInput/ShootingLocationInput.module.scss
var ShootingLocationInput_module = __webpack_require__(50508);
var ShootingLocationInput_module_default = /*#__PURE__*/__webpack_require__.n(ShootingLocationInput_module);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Table.js + 1 modules
var Table = __webpack_require__(7906);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableHead/TableHead.js + 1 modules
var TableHead = __webpack_require__(53184);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(53816);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableCell/TableCell.js + 1 modules
var TableCell = __webpack_require__(53252);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js + 1 modules
var FormHelperText = __webpack_require__(56815);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Edit.js
var esm_Edit = __webpack_require__(51797);
// EXTERNAL MODULE: ./src/components/GoogleMapsAutoComplete/GoogleMapsAutoComplete.tsx
var GoogleMapsAutoComplete = __webpack_require__(44414);
// EXTERNAL MODULE: ./src/utils/google-location.tsx
var google_location = __webpack_require__(2892);
;// CONCATENATED MODULE: ./src/pages/Show/CreateShow/ShootingLocationInput/ShootingLocationInput.tsx












var ShootingLocationInput = function ShootingLocationInput(props) {
  var _useState = (0,react.useState)(props.value ? props.value : []),
      tableData = _useState[0],
      setTableData = _useState[1];

  var _React$useState = react.useState(""),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      shootingLocationName = _React$useState2[0],
      setShootingLocationName = _React$useState2[1];

  var _React$useState3 = react.useState(false),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      shootingLocationNameError = _React$useState4[0],
      setShootingLocationNameError = _React$useState4[1];

  var _React$useState5 = react.useState(null),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      shootingLocationLocation = _React$useState6[0],
      setShootingLocationLocation = _React$useState6[1];

  var _React$useState7 = react.useState(0),
      _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
      shootingLocationLocationKey = _React$useState8[0],
      setShootingLocationLocationKey = _React$useState8[1];

  var _React$useState9 = react.useState(false),
      _React$useState10 = (0,slicedToArray/* default */.Z)(_React$useState9, 2),
      shootingLocationLocationError = _React$useState10[0],
      setShootingLocationLocationError = _React$useState10[1];

  var _React$useState11 = react.useState(""),
      _React$useState12 = (0,slicedToArray/* default */.Z)(_React$useState11, 2),
      shootingLocationMeetingPoint = _React$useState12[0],
      setShootingLocationMeetingPoint = _React$useState12[1];

  var _React$useState13 = react.useState(false),
      _React$useState14 = (0,slicedToArray/* default */.Z)(_React$useState13, 2),
      shootingLocationMeetingPointError = _React$useState14[0],
      setShootingLocationMeetingPointError = _React$useState14[1];

  var _React$useState15 = react.useState(""),
      _React$useState16 = (0,slicedToArray/* default */.Z)(_React$useState15, 2),
      shootingLocationPublicTransport = _React$useState16[0],
      setShootingLocationPublicTransport = _React$useState16[1];

  var _React$useState17 = react.useState(false),
      _React$useState18 = (0,slicedToArray/* default */.Z)(_React$useState17, 2),
      shootingLocationPublicTransportError = _React$useState18[0],
      setShootingLocationPublicTransportError = _React$useState18[1];

  var _React$useState19 = react.useState(""),
      _React$useState20 = (0,slicedToArray/* default */.Z)(_React$useState19, 2),
      shootingLocationParking = _React$useState20[0],
      setShootingLocationParking = _React$useState20[1];

  var _React$useState21 = react.useState(false),
      _React$useState22 = (0,slicedToArray/* default */.Z)(_React$useState21, 2),
      shootingLocationParkingError = _React$useState22[0],
      setShootingLocationParkingError = _React$useState22[1];

  var _React$useState23 = react.useState(false),
      _React$useState24 = (0,slicedToArray/* default */.Z)(_React$useState23, 2),
      isEditShootingLocation = _React$useState24[0],
      setIsEditShootingLocation = _React$useState24[1];

  var _React$useState25 = react.useState(null),
      _React$useState26 = (0,slicedToArray/* default */.Z)(_React$useState25, 2),
      editShootingLocationIndex = _React$useState26[0],
      setEditShootingLocationIndex = _React$useState26[1];

  var _getConfig = config_default()(),
      publicRuntimeConfig = _getConfig.publicRuntimeConfig;

  var shootingLocationValid = false;

  var isShootLocationValid = function isShootLocationValid() {
    setShootingLocationNameError(shootingLocationName === "");
    setShootingLocationLocationError(shootingLocationLocation === null);
    setShootingLocationMeetingPointError(shootingLocationMeetingPoint === "");
    setShootingLocationPublicTransportError(shootingLocationPublicTransport === "");
    setShootingLocationParkingError(shootingLocationParking === "");

    if (shootingLocationName === "" || shootingLocationLocation === null || shootingLocationParking === "") {
      shootingLocationValid = false;
    } else {
      shootingLocationValid = true;
    }

    return shootingLocationValid;
  };

  var addShootingLocation = function addShootingLocation() {
    if (!isShootLocationValid()) {
      return;
    }

    var newShootingLocation = {
      name: shootingLocationName,
      audienceMeetingPointDirections: shootingLocationMeetingPoint,
      publicTransportDirections: shootingLocationPublicTransport,
      parkingDirections: shootingLocationParking,
      placeId: "",
      latitude: 0,
      longitude: 0,
      longLocation: "",
      shortLocation: "",
      detailsJson: "",
      country: "",
      unitOrApartmentNumber: "",
      street: "",
      suburb: "",
      state: "",
      postCode: "",
      canBeDeleted: true,
      canBeEdited: true,
      description: ""
    };
    (0,google_location/* setGeocoderInfo */.j)(shootingLocationLocation, newShootingLocation);
    tableData === null || tableData === void 0 ? void 0 : tableData.push(newShootingLocation);

    if (props.onChange != null) {
      props.onChange(tableData);
    }

    resetShootingLocationFields();
  };

  var handleEditShootingLocationIcon = function handleEditShootingLocationIcon(index) {
    setIsEditShootingLocation(!isEditShootingLocation);

    if (isEditShootingLocation) {
      resetShootingLocationFields();
      setEditShootingLocationIndex(null);
    } else {
      setEditShootingLocationIndex(index);
      var shootingLocationDetails = tableData[index];

      if (shootingLocationDetails.name) {
        setShootingLocationName(shootingLocationDetails.name);
      }

      if (shootingLocationDetails.audienceMeetingPointDirections) {
        setShootingLocationMeetingPoint(shootingLocationDetails.audienceMeetingPointDirections);
      }

      if (shootingLocationDetails.publicTransportDirections) {
        setShootingLocationPublicTransport(shootingLocationDetails.publicTransportDirections);
      }

      if (shootingLocationDetails.parkingDirections) {
        setShootingLocationParking(shootingLocationDetails.parkingDirections);
      }
    }
  };

  var editShootingLocation = function editShootingLocation(index) {
    var isValid = isShootLocationValid();

    if (!isValid) {
      return;
    }

    if (index !== null && index >= 0) {
      var updatedShootingLocation = {
        name: shootingLocationName,
        audienceMeetingPointDirections: shootingLocationMeetingPoint,
        publicTransportDirections: shootingLocationPublicTransport,
        parkingDirections: shootingLocationParking,
        placeId: "",
        latitude: 0,
        longitude: 0,
        longLocation: "",
        shortLocation: "",
        detailsJson: "",
        country: "",
        unitOrApartmentNumber: "",
        street: "",
        suburb: "",
        state: "",
        postCode: "",
        canBeDeleted: true,
        canBeEdited: true,
        description: ""
      };
      (0,google_location/* setGeocoderInfo */.j)(shootingLocationLocation, updatedShootingLocation);
      tableData[index] = updatedShootingLocation;

      if (props.onChange != null) {
        props.onChange(tableData);
      }

      setIsEditShootingLocation(false);
    }

    resetShootingLocationFields();
  };

  var removeShootingLocation = function removeShootingLocation(index) {
    if (tableData != null) {
      var data = tableData.filter(function (_, i) {
        return i !== index;
      });
      setTableData(data);

      if (props.onChange != null) {
        props.onChange(data);
      }
    }
  };

  var resetShootingLocationFields = function resetShootingLocationFields() {
    setShootingLocationName("");
    setShootingLocationLocation(null);
    setShootingLocationLocationKey(shootingLocationLocationKey + 1); // resets the google map autocomplete

    setShootingLocationMeetingPoint("");
    setShootingLocationPublicTransport("");
    setShootingLocationParking("");
  }; // useEffect(() => {
  //     if (shootingLocationName === "" || 
  //         shootingLocationLocation === null ||
  //         shootingLocationParking === "") {
  //         shootingLocationValid = false;
  //     } else {
  //         shootingLocationValid = true;
  //     }
  // }, [shootingLocationName, shootingLocationLocation, shootingLocationParking]);


  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledEngineProvider/* default */.Z, {
    injectFirst: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormControl/* default */.Z, {
      error: props.error ? true : false,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
          p: 2,
          border: 1,
          borderRadius: 1,
          mb: 2,
          borderColor: props.error ? "red" : "false"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Table/* default */.Z, {
          "aria-label": "table",
          sx: {
            mb: 2
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TableHead/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                children: "Shooting location(s)"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {})]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TableBody/* default */.Z, {
            "data-cy": "modal-shootinglocation-table",
            children: tableData === null || tableData === void 0 ? void 0 : tableData.map(function (shootingLocation, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                "data-id": shootingLocation.id,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                  width: "100%",
                  children: shootingLocation.name
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                  className: (ShootingLocationInput_module_default()).iconColumn,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    "data-cy": "edit-shooting-location-icon",
                    onClick: function onClick() {
                      return handleEditShootingLocationIcon(index);
                    },
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                      title: isEditShootingLocation ? "Cancel edit shooting location" : "Edit shooting location",
                      placement: "top",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Edit/* default */.Z, {})
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                  className: (ShootingLocationInput_module_default()).iconColumn,
                  children: shootingLocation.canBeDeleted && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    "data-cy": "deleteIcon",
                    onClick: function onClick() {
                      return removeShootingLocation(index);
                    },
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                      title: "Delete shooting location",
                      placement: "top",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Delete/* default */.Z, {})
                    })
                  })
                })]
              }, index);
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
          container: true,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sx: {
              mb: 1
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
              className: (ShootingLocationInput_module_default()).input,
              label: "Venue Name",
              required: true,
              error: shootingLocationNameError,
              helperText: shootingLocationNameError ? "Name is mandatory." : "",
              value: shootingLocationName,
              type: "text",
              onChange: function onChange(event) {
                setShootingLocationName(event.target.value);
                setShootingLocationNameError(event.target.value === "");
              },
              "data-cy": "modal-shootinglocation-name"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sx: {
              mb: 1
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(GoogleMapsAutoComplete/* default */.Z, {
              id: "google-maps-autocomplete",
              apiKey: publicRuntimeConfig.googleMapsApiKey,
              value: shootingLocationLocation,
              error: shootingLocationLocationError,
              helperText: shootingLocationLocationError ? "Location is mandatory." : "",
              onChange: function onChange(value) {
                setShootingLocationLocation(value);
                setShootingLocationLocationError(value == null);
              },
              "data-cy": "modal-shooting-location-location"
            }, shootingLocationLocationKey)
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sx: {
              mb: 1
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
              className: (ShootingLocationInput_module_default()).input,
              label: "Audience meeting point instructions",
              required: true,
              error: shootingLocationMeetingPointError,
              helperText: shootingLocationMeetingPointError ? "Audience meeting point instructions is mandatory." : "",
              value: shootingLocationMeetingPoint,
              multiline: true,
              minRows: 2,
              maxRows: 4,
              onChange: function onChange(event) {
                setShootingLocationMeetingPoint(event.target.value);
                setShootingLocationMeetingPointError(event.target.value === "");
              },
              "data-cy": "modal-shootinglocation-meeting-point"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sx: {
              mb: 1
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
              className: (ShootingLocationInput_module_default()).input,
              label: "Parking instructions",
              required: true,
              error: shootingLocationParkingError,
              helperText: shootingLocationParkingError ? "Parking instructions is mandatory." : "",
              value: shootingLocationParking,
              multiline: true,
              minRows: 2,
              maxRows: 4,
              onChange: function onChange(event) {
                setShootingLocationParking(event.target.value);
                setShootingLocationParkingError(event.target.value === "");
              },
              "data-cy": "modal-shootinglocation-parking"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sx: {
              mb: 1
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
              className: (ShootingLocationInput_module_default()).input,
              label: "Public transport instructions",
              required: true,
              error: shootingLocationPublicTransportError,
              helperText: shootingLocationPublicTransportError ? "Public transport instructions is mandatory." : "",
              value: shootingLocationPublicTransport,
              multiline: true,
              minRows: 2,
              maxRows: 4,
              onChange: function onChange(event) {
                setShootingLocationPublicTransport(event.target.value);
                setShootingLocationPublicTransportError(event.target.value === "");
              },
              "data-cy": "modal-shootinglocation-public-transport"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sx: {
              display: 'flex'
            },
            alignItems: "center",
            justifyContent: "center",
            children: isEditShootingLocation ? /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              onClick: function onClick() {
                return editShootingLocation(editShootingLocationIndex);
              },
              "data-cy": "modal-shootinglocation-submit",
              children: "Edit shooting location"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              onClick: function onClick() {
                return addShootingLocation();
              },
              "data-cy": "modal-shootinglocation-submit",
              children: "Add shooting location"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
          children: props.helperText
        })]
      })
    })
  });
};

/* harmony default export */ var ShootingLocationInput_ShootingLocationInput = (ShootingLocationInput);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js + 2 modules
var LocalizationProvider = __webpack_require__(52359);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/DesktopDatePicker/DesktopDatePicker.js
var DesktopDatePicker = __webpack_require__(87664);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/TimePicker/TimePicker.js + 5 modules
var TimePicker = __webpack_require__(45459);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/AdapterDayjs/index.js + 1 modules
var AdapterDayjs = __webpack_require__(26829);
// EXTERNAL MODULE: ./src/utils/constants.tsx
var constants = __webpack_require__(39509);
;// CONCATENATED MODULE: ./src/pages/Show/CreateShow/CreateShow.tsx







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























var CreateShow = function CreateShow(_ref) {
  var _viewModel$termsAndCo;

  var showId = _ref.showId,
      onSuccess = _ref.onSuccess,
      type = _ref.type,
      templates = _ref.templates;

  var CreateShowViewModel = /*#__PURE__*/(0,createClass/* default */.Z)(function CreateShowViewModel(_ref2) {
    var show = _ref2.show;

    (0,classCallCheck/* default */.Z)(this, CreateShowViewModel);

    (0,defineProperty/* default */.Z)(this, "show", void 0);

    (0,defineProperty/* default */.Z)(this, "showTemplates", void 0);

    (0,defineProperty/* default */.Z)(this, "image", void 0);

    (0,defineProperty/* default */.Z)(this, "objectURL", void 0);

    (0,defineProperty/* default */.Z)(this, "termsAndConditions", void 0);

    (0,defineProperty/* default */.Z)(this, "termsAndConditionsObjURL", void 0);

    (0,defineProperty/* default */.Z)(this, "validationErrors", void 0);

    this.show = show;
  });

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      snackbarErrorOpen = _React$useState2[0],
      setSnackbarErrorOpen = _React$useState2[1];

  var _React$useState3 = react.useState(false),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      snackbarSuccessOpen = _React$useState4[0],
      setSnackbarSuccessOpen = _React$useState4[1];

  var _React$useState5 = react.useState(false),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      loading = _React$useState6[0],
      setLoading = _React$useState6[1];

  var _React$useState7 = react.useState(""),
      _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
      dialogTitle = _React$useState8[0],
      setDialogTitle = _React$useState8[1];

  var _React$useState9 = react.useState(""),
      _React$useState10 = (0,slicedToArray/* default */.Z)(_React$useState9, 2),
      submitMessage = _React$useState10[0],
      setSubmitMessage = _React$useState10[1];

  var _React$useState11 = react.useState(""),
      _React$useState12 = (0,slicedToArray/* default */.Z)(_React$useState11, 2),
      successMessage = _React$useState12[0],
      setSuccessMessage = _React$useState12[1];

  var _React$useState13 = react.useState(""),
      _React$useState14 = (0,slicedToArray/* default */.Z)(_React$useState13, 2),
      errorMessage = _React$useState14[0],
      setErrorMessage = _React$useState14[1];

  var _React$useState15 = react.useState(false),
      _React$useState16 = (0,slicedToArray/* default */.Z)(_React$useState15, 2),
      open = _React$useState16[0],
      setOpen = _React$useState16[1];

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(new CreateShowViewModel({
    show: new Show()
  })),
      viewModel = _useState[0],
      setViewModel = _useState[1];

  var _React$useState17 = react.useState(""),
      _React$useState18 = (0,slicedToArray/* default */.Z)(_React$useState17, 2),
      showName = _React$useState18[0],
      setShowName = _React$useState18[1];

  var _React$useState19 = react.useState(""),
      _React$useState20 = (0,slicedToArray/* default */.Z)(_React$useState19, 2),
      synopsis = _React$useState20[0],
      setSynopsis = _React$useState20[1];

  var _React$useState21 = react.useState(""),
      _React$useState22 = (0,slicedToArray/* default */.Z)(_React$useState21, 2),
      networkName = _React$useState22[0],
      setNetworkName = _React$useState22[1];

  var _React$useState23 = react.useState(""),
      _React$useState24 = (0,slicedToArray/* default */.Z)(_React$useState23, 2),
      productionCompany = _React$useState24[0],
      setProductionCompany = _React$useState24[1];

  var _React$useState25 = react.useState(constants/* defaultInitialFillPercentageStr */.JD),
      _React$useState26 = (0,slicedToArray/* default */.Z)(_React$useState25, 2),
      initialFillPercentage = _React$useState26[0],
      setInitialFillPercentage = _React$useState26[1];

  var _React$useState27 = react.useState(""),
      _React$useState28 = (0,slicedToArray/* default */.Z)(_React$useState27, 2),
      minAgeRequirement = _React$useState28[0],
      setMinAgeRequirement = _React$useState28[1];

  var _React$useState29 = react.useState(""),
      _React$useState30 = (0,slicedToArray/* default */.Z)(_React$useState29, 2),
      ticketingStartTimeOffset = _React$useState30[0],
      setTicketingStartTimeOffset = _React$useState30[1];

  var _React$useState31 = react.useState(""),
      _React$useState32 = (0,slicedToArray/* default */.Z)(_React$useState31, 2),
      url = _React$useState32[0],
      setUrl = _React$useState32[1];

  var _React$useState33 = react.useState(null),
      _React$useState34 = (0,slicedToArray/* default */.Z)(_React$useState33, 2),
      shootingLocations = _React$useState34[0],
      setShootingLocations = _React$useState34[1];

  var _React$useState35 = react.useState(null),
      _React$useState36 = (0,slicedToArray/* default */.Z)(_React$useState35, 2),
      showLaunchDate = _React$useState36[0],
      setShowLaunchDate = _React$useState36[1];

  var _React$useState37 = react.useState(null),
      _React$useState38 = (0,slicedToArray/* default */.Z)(_React$useState37, 2),
      showLaunchTime = _React$useState38[0],
      setShowLaunchTime = _React$useState38[1];

  var _React$useState39 = react.useState(""),
      _React$useState40 = (0,slicedToArray/* default */.Z)(_React$useState39, 2),
      firstEmailTemplate = _React$useState40[0],
      setFirstEmailTemplate = _React$useState40[1];

  var _React$useState41 = react.useState(""),
      _React$useState42 = (0,slicedToArray/* default */.Z)(_React$useState41, 2),
      reminderEmailTemplate = _React$useState42[0],
      setReminderEmailTemplate = _React$useState42[1];

  var _React$useState43 = react.useState(""),
      _React$useState44 = (0,slicedToArray/* default */.Z)(_React$useState43, 2),
      confirmEmailTemplate = _React$useState44[0],
      setConfirmEmailTemplate = _React$useState44[1];

  var _React$useState45 = react.useState(""),
      _React$useState46 = (0,slicedToArray/* default */.Z)(_React$useState45, 2),
      groupEmailTemplate = _React$useState46[0],
      setGroupEmailTemplate = _React$useState46[1];

  var _React$useState47 = react.useState(""),
      _React$useState48 = (0,slicedToArray/* default */.Z)(_React$useState47, 2),
      ticketEmailTemplate = _React$useState48[0],
      setTicketEmailTemplate = _React$useState48[1];

  var _React$useState49 = react.useState(""),
      _React$useState50 = (0,slicedToArray/* default */.Z)(_React$useState49, 2),
      confirmSmsTemplate = _React$useState50[0],
      setConfirmSmsTemplate = _React$useState50[1];

  var _React$useState51 = react.useState(""),
      _React$useState52 = (0,slicedToArray/* default */.Z)(_React$useState51, 2),
      reminderSmsTemplate = _React$useState52[0],
      setReminderSmsTemplate = _React$useState52[1];

  var _React$useState53 = react.useState(""),
      _React$useState54 = (0,slicedToArray/* default */.Z)(_React$useState53, 2),
      firstEmailTemplateSubject = _React$useState54[0],
      setFirstEmailTemplateSubject = _React$useState54[1];

  var _React$useState55 = react.useState(""),
      _React$useState56 = (0,slicedToArray/* default */.Z)(_React$useState55, 2),
      reminderEmailTemplateSubject = _React$useState56[0],
      setReminderEmailTemplateSubject = _React$useState56[1];

  var _React$useState57 = react.useState(""),
      _React$useState58 = (0,slicedToArray/* default */.Z)(_React$useState57, 2),
      confirmEmailTemplateSubject = _React$useState58[0],
      setConfirmEmailTemplateSubject = _React$useState58[1];

  var _React$useState59 = react.useState(""),
      _React$useState60 = (0,slicedToArray/* default */.Z)(_React$useState59, 2),
      groupEmailTemplateSubject = _React$useState60[0],
      setGroupEmailTemplateSubject = _React$useState60[1];

  var _React$useState61 = react.useState(""),
      _React$useState62 = (0,slicedToArray/* default */.Z)(_React$useState61, 2),
      ticketEmailTemplateSubject = _React$useState62[0],
      setTicketEmailTemplateSubject = _React$useState62[1];

  var _React$useState63 = react.useState(""),
      _React$useState64 = (0,slicedToArray/* default */.Z)(_React$useState63, 2),
      confirmSmsTemplateSubject = _React$useState64[0],
      setConfirmSmsTemplateSubject = _React$useState64[1];

  var _React$useState65 = react.useState(""),
      _React$useState66 = (0,slicedToArray/* default */.Z)(_React$useState65, 2),
      reminderSmsTemplateSubject = _React$useState66[0],
      setReminderSmsTemplateSubject = _React$useState66[1];

  var emptyContentJson = JSON.stringify(emptyInputContentVariable);

  var _React$useState67 = react.useState(emptyContentJson),
      _React$useState68 = (0,slicedToArray/* default */.Z)(_React$useState67, 2),
      firstEmailTemplateContent = _React$useState68[0],
      setFirstEmailTemplateContent = _React$useState68[1];

  var _React$useState69 = react.useState(emptyContentJson),
      _React$useState70 = (0,slicedToArray/* default */.Z)(_React$useState69, 2),
      reminderEmailTemplateContent = _React$useState70[0],
      setReminderEmailTemplateContent = _React$useState70[1];

  var _React$useState71 = react.useState(emptyContentJson),
      _React$useState72 = (0,slicedToArray/* default */.Z)(_React$useState71, 2),
      confirmEmailTemplateContent = _React$useState72[0],
      setConfirmEmailTemplateContent = _React$useState72[1];

  var _React$useState73 = react.useState(emptyContentJson),
      _React$useState74 = (0,slicedToArray/* default */.Z)(_React$useState73, 2),
      groupEmailTemplateContent = _React$useState74[0],
      setGroupEmailTemplateContent = _React$useState74[1];

  var _React$useState75 = react.useState(emptyContentJson),
      _React$useState76 = (0,slicedToArray/* default */.Z)(_React$useState75, 2),
      ticketEmailTemplateContent = _React$useState76[0],
      setTicketEmailTemplateContent = _React$useState76[1];

  var _React$useState77 = react.useState(emptyContentJson),
      _React$useState78 = (0,slicedToArray/* default */.Z)(_React$useState77, 2),
      confirmSmsTemplateContent = _React$useState78[0],
      setConfirmSmsTemplateContent = _React$useState78[1];

  var _React$useState79 = react.useState(emptyContentJson),
      _React$useState80 = (0,slicedToArray/* default */.Z)(_React$useState79, 2),
      reminderSmsTemplateContent = _React$useState80[0],
      setReminderSmsTemplateContent = _React$useState80[1];

  var _React$useState81 = react.useState(false),
      _React$useState82 = (0,slicedToArray/* default */.Z)(_React$useState81, 2),
      submitDisabled = _React$useState82[0],
      setSubmitDisabled = _React$useState82[1];

  var _React$useState83 = react.useState(false),
      _React$useState84 = (0,slicedToArray/* default */.Z)(_React$useState83, 2),
      showNameError = _React$useState84[0],
      setShowNameError = _React$useState84[1];

  var _React$useState85 = react.useState(false),
      _React$useState86 = (0,slicedToArray/* default */.Z)(_React$useState85, 2),
      networkNameError = _React$useState86[0],
      setNetworkNameError = _React$useState86[1];

  var _React$useState87 = react.useState(false),
      _React$useState88 = (0,slicedToArray/* default */.Z)(_React$useState87, 2),
      termsAndConditionsError = _React$useState88[0],
      setTermsAndConditionsError = _React$useState88[1];

  var _React$useState89 = react.useState(false),
      _React$useState90 = (0,slicedToArray/* default */.Z)(_React$useState89, 2),
      productionCompanyError = _React$useState90[0],
      setProductionCompanyError = _React$useState90[1];

  var _React$useState91 = react.useState(false),
      _React$useState92 = (0,slicedToArray/* default */.Z)(_React$useState91, 2),
      initialFillPercentageError = _React$useState92[0],
      setInitialFillPercentageError = _React$useState92[1];

  var _React$useState93 = react.useState(false),
      _React$useState94 = (0,slicedToArray/* default */.Z)(_React$useState93, 2),
      urlError = _React$useState94[0],
      setUrlError = _React$useState94[1];

  var _React$useState95 = react.useState(false),
      _React$useState96 = (0,slicedToArray/* default */.Z)(_React$useState95, 2),
      shootingLocationsError = _React$useState96[0],
      setShootingLocationsError = _React$useState96[1];

  var _React$useState97 = react.useState(false),
      _React$useState98 = (0,slicedToArray/* default */.Z)(_React$useState97, 2),
      ticketingStartTimeOffsetError = _React$useState98[0],
      setTicketingStartTimeOffsetError = _React$useState98[1];

  var _React$useState99 = react.useState(false),
      _React$useState100 = (0,slicedToArray/* default */.Z)(_React$useState99, 2),
      showLaunchDateError = _React$useState100[0],
      setShowLaunchDateError = _React$useState100[1];

  var _React$useState101 = react.useState(false),
      _React$useState102 = (0,slicedToArray/* default */.Z)(_React$useState101, 2),
      showLaunchTimeError = _React$useState102[0],
      setShowLaunchTimeError = _React$useState102[1];

  var _React$useState103 = react.useState(false),
      _React$useState104 = (0,slicedToArray/* default */.Z)(_React$useState103, 2),
      loadingAssets = _React$useState104[0],
      setLoadingAssets = _React$useState104[1];

  var clearForm = function clearForm() {
    setShowName("");
    setSynopsis("");
    setNetworkName("");
    setProductionCompany(""); //setInitialFillPercentage("");

    setMinAgeRequirement("");
    setTicketingStartTimeOffset("");
    setUrl("");
    setShowNameError(false);
    setShowLaunchDateError(false);
    setShowLaunchTimeError(false);
    setNetworkNameError(false);
    setProductionCompanyError(false);
    setInitialFillPercentageError(false);
    setUrlError(false);
    setTicketingStartTimeOffsetError(false);
    removeImage();
    removeTermsAndConditions();
    setFirstEmailTemplate("");
    setFirstEmailTemplateContent(emptyContentJson);
    setFirstEmailTemplateSubject("");
    setReminderEmailTemplate("");
    setReminderEmailTemplateContent(emptyContentJson);
    setReminderEmailTemplateSubject("");
    setConfirmEmailTemplate("");
    setConfirmEmailTemplateContent(emptyContentJson);
    setConfirmEmailTemplateSubject("");
    setGroupEmailTemplate("");
    setGroupEmailTemplateContent(emptyContentJson);
    setGroupEmailTemplateSubject("");
    setTicketEmailTemplate("");
    setTicketEmailTemplateContent(emptyContentJson);
    setTicketEmailTemplateSubject("");
    setConfirmSmsTemplate("");
    setConfirmSmsTemplateContent(emptyContentJson);
    setConfirmSmsTemplateSubject("");
    setReminderSmsTemplate("");
    setReminderSmsTemplateContent(emptyContentJson);
    setReminderSmsTemplateSubject("");
    setShootingLocations(null);
    setShowLaunchDate(null);
    setShowLaunchTime(null);
  };

  (0,react.useEffect)(function () {
    setSubmitDisabled(showName === "" || networkName === "" || synopsis === "" || productionCompany === "" || //initialFillPercentage === "" ||
    url === "" || ticketingStartTimeOffset === "" || shootingLocations === null || (shootingLocations === null || shootingLocations === void 0 ? void 0 : shootingLocations.length) === 0 || showLaunchDate === null || showLaunchTime === null);
  }, [showName, synopsis, networkName, productionCompany, initialFillPercentage, url, ticketingStartTimeOffset, shootingLocations, showLaunchTime, showLaunchDate]);
  (0,react.useEffect)(function () {
    if (router !== null && router !== void 0 && router.asPath.includes("create-show")) {
      setOpen(true);
      setDialogTitle("Create New Show");
      setSubmitMessage("Create Show");
      setSuccessMessage("Show Successfully Created!");
      setErrorMessage("Show Creation Failed!");
    }

    if (router !== null && router !== void 0 && router.asPath.includes("edit-show")) {
      setOpen(true);
      setDialogTitle("Edit Show");
      setSubmitMessage("Update Show");
      setSuccessMessage("Show Successfully Updated!");
      setErrorMessage("Show Update Failed!");
      prePopulateForm();
    }
  }, [router]);

  var handlePostShow = function handlePostShow(values) {
    var _templates$find, _templates$find2, _templates$find3, _templates$find4, _templates$find5, _templates$find6, _templates$find7, _replaceDate;

    setLoading(true);
    setViewModel(_objectSpread({}, viewModel));
    var showTemplates = [{
      showTemplateType: ShowTemplateType.FirstEmailTemplate,
      templateId: templates === null || templates === void 0 ? void 0 : (_templates$find = templates.find(function (t) {
        return t.name == firstEmailTemplate;
      })) === null || _templates$find === void 0 ? void 0 : _templates$find.id,
      inputContentVariablesJson: firstEmailTemplateContent,
      subject: firstEmailTemplateSubject
    }, {
      showTemplateType: ShowTemplateType.ReminderEmailTemplate,
      templateId: templates === null || templates === void 0 ? void 0 : (_templates$find2 = templates.find(function (t) {
        return t.name == reminderEmailTemplate;
      })) === null || _templates$find2 === void 0 ? void 0 : _templates$find2.id,
      inputContentVariablesJson: reminderEmailTemplateContent,
      subject: reminderEmailTemplateSubject
    }, {
      showTemplateType: ShowTemplateType.ConfirmEmailTemplate,
      templateId: templates === null || templates === void 0 ? void 0 : (_templates$find3 = templates.find(function (t) {
        return t.name == confirmEmailTemplate;
      })) === null || _templates$find3 === void 0 ? void 0 : _templates$find3.id,
      inputContentVariablesJson: confirmEmailTemplateContent,
      subject: confirmEmailTemplateSubject
    }, {
      showTemplateType: ShowTemplateType.GroupEmailTemplate,
      templateId: templates === null || templates === void 0 ? void 0 : (_templates$find4 = templates.find(function (t) {
        return t.name == groupEmailTemplate;
      })) === null || _templates$find4 === void 0 ? void 0 : _templates$find4.id,
      inputContentVariablesJson: groupEmailTemplateContent,
      subject: groupEmailTemplateSubject
    }, {
      showTemplateType: ShowTemplateType.TicketEmailTemplate,
      templateId: templates === null || templates === void 0 ? void 0 : (_templates$find5 = templates.find(function (t) {
        return t.name == ticketEmailTemplate;
      })) === null || _templates$find5 === void 0 ? void 0 : _templates$find5.id,
      inputContentVariablesJson: ticketEmailTemplateContent,
      subject: ticketEmailTemplateSubject
    }, {
      showTemplateType: ShowTemplateType.ConfirmSmsTemplate,
      templateId: templates === null || templates === void 0 ? void 0 : (_templates$find6 = templates.find(function (t) {
        return t.name == confirmSmsTemplate;
      })) === null || _templates$find6 === void 0 ? void 0 : _templates$find6.id,
      inputContentVariablesJson: confirmSmsTemplateContent,
      subject: confirmSmsTemplateSubject
    }, {
      showTemplateType: ShowTemplateType.ReminderSmsTemplate,
      templateId: templates === null || templates === void 0 ? void 0 : (_templates$find7 = templates.find(function (t) {
        return t.name == reminderSmsTemplate;
      })) === null || _templates$find7 === void 0 ? void 0 : _templates$find7.id,
      inputContentVariablesJson: reminderSmsTemplateContent,
      subject: reminderSmsTemplateSubject
    }];
    var show = {
      id: showId ? showId : undefined,
      name: showName,
      synopsis: synopsis,
      showTemplatesJSON: JSON.stringify(showTemplates),
      defaultInitialFillPercentage: Number(initialFillPercentage),
      defaultMinimumAgeRequirement: Number(minAgeRequirement),
      defaultTicketingStartTimeOffset: ticketingStartTimeOffset,
      networkName: networkName,
      productionCompany: productionCompany,
      publicRouteUrL: url,
      shootingLocationsJSON: JSON.stringify(shootingLocations),
      termsAndConditions: viewModel.termsAndConditions ? viewModel.termsAndConditions : null,
      image: viewModel.image ? viewModel.image : null,
      showLaunch: (_replaceDate = (0,dates/* replaceDate */.Kp)(showLaunchTime, showLaunchDate)) === null || _replaceDate === void 0 ? void 0 : _replaceDate.toJSON()
    };

    if (type === "edit") {
      (0,ShowService/* editShow */.iU)(show).then(function (res) {
        if (res.status == 200) {
          setOpen(false);
          setLoading(false);
          setSnackbarSuccessOpen(true);
          onSuccess();
        } else {
          setOpen(false);
          setLoading(false);
          setSnackbarErrorOpen(true);
        }
      });
      return;
    }

    (0,ShowService/* createShow */.RI)(show).then(function (res) {
      if (res.showId) {
        setOpen(false);
        setLoading(false);
        setSnackbarSuccessOpen(true);
        router.push("/show/".concat(res.showId));
      } else {
        setOpen(false);
        setLoading(false);
        setSnackbarErrorOpen(true);
      }
    });
    clearForm();
  };

  var handleDialogClose = function handleDialogClose() {
    setOpen(false);
    clearForm();
    router.replace("/", undefined, {
      shallow: true
    });
  };

  var handleClose = function handleClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarErrorOpen(false);
    setSnackbarSuccessOpen(false);
    setLoading(false);
  };

  var setTemplate = function setTemplate(prePopulateData, templateName) {
    var _prePopulateData$show;

    var showTemplate = (_prePopulateData$show = prePopulateData.showTemplates) === null || _prePopulateData$show === void 0 ? void 0 : _prePopulateData$show.find(function (t) {
      return t.showTemplateType == templateName;
    });
    var template = templates === null || templates === void 0 ? void 0 : templates.find(function (t) {
      return t.id == (showTemplate === null || showTemplate === void 0 ? void 0 : showTemplate.templateId);
    });
    var content = showTemplate !== null && showTemplate !== void 0 && showTemplate.inputContentVariablesJson ? showTemplate === null || showTemplate === void 0 ? void 0 : showTemplate.inputContentVariablesJson : emptyContentJson;

    switch (templateName) {
      case 'FirstEmailTemplate':
        setFirstEmailTemplate(template === null || template === void 0 ? void 0 : template.name);
        setFirstEmailTemplateContent(content);
        setFirstEmailTemplateSubject(showTemplate === null || showTemplate === void 0 ? void 0 : showTemplate.subject);
        break;

      case 'ReminderEmailTemplate':
        setReminderEmailTemplate(template === null || template === void 0 ? void 0 : template.name);
        setReminderEmailTemplateContent(content);
        setReminderEmailTemplateSubject(showTemplate === null || showTemplate === void 0 ? void 0 : showTemplate.subject);
        break;

      case 'ConfirmEmailTemplate':
        setConfirmEmailTemplate(template === null || template === void 0 ? void 0 : template.name);
        setConfirmEmailTemplateContent(content);
        setConfirmEmailTemplateSubject(showTemplate === null || showTemplate === void 0 ? void 0 : showTemplate.subject);
        break;

      case 'GroupEmailTemplate':
        setGroupEmailTemplate(template === null || template === void 0 ? void 0 : template.name);
        setGroupEmailTemplateContent(content);
        setGroupEmailTemplateSubject(showTemplate === null || showTemplate === void 0 ? void 0 : showTemplate.subject);
        break;

      case 'TicketEmailTemplate':
        setTicketEmailTemplate(template === null || template === void 0 ? void 0 : template.name);
        setTicketEmailTemplateContent(content);
        setTicketEmailTemplateSubject(showTemplate === null || showTemplate === void 0 ? void 0 : showTemplate.subject);
        break;

      case 'ConfirmSmsTemplate':
        setConfirmSmsTemplate(template === null || template === void 0 ? void 0 : template.name);
        setConfirmSmsTemplateContent(content);
        setConfirmSmsTemplateSubject(showTemplate === null || showTemplate === void 0 ? void 0 : showTemplate.subject);
        break;

      case 'ReminderSmsTemplate':
        setReminderSmsTemplate(template === null || template === void 0 ? void 0 : template.name);
        setReminderSmsTemplateContent(content);
        setReminderSmsTemplateSubject(showTemplate === null || showTemplate === void 0 ? void 0 : showTemplate.subject);
        break;
    }
  };

  var prePopulateForm = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var sessionShowData, prePopulateData, imageResponse, blob, termsResponse, filename, _blob, termsFile;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sessionShowData = sessionStorage.getItem('prepopulateData');
              prePopulateData = sessionShowData ? JSON.parse(sessionShowData) : null;

              if (!prePopulateData) {
                _context.next = 34;
                break;
              }

              setShowName(prePopulateData.name ? prePopulateData.name : "");
              setSynopsis(prePopulateData.synopsis ? prePopulateData.synopsis : "");
              setNetworkName(prePopulateData.networkName ? prePopulateData.networkName : "");
              setProductionCompany(prePopulateData.productionCompany ? prePopulateData.productionCompany : "");
              setShowLaunchDate(prePopulateData.showLaunch ? dayjs_min_default()(prePopulateData.showLaunch) : null);
              setShowLaunchTime(prePopulateData.showLaunch ? dayjs_min_default()(prePopulateData.showLaunch) : null);
              /*setInitialFillPercentage(
                prePopulateData.defaultInitialFillPercentage
                  ? prePopulateData.defaultInitialFillPercentage
                  : ""
              );*/

              setMinAgeRequirement(prePopulateData.defaultMinimumAgeRequirement ? prePopulateData.defaultMinimumAgeRequirement.toString() : "");
              setTicketingStartTimeOffset(prePopulateData.defaultTicketingStartTimeOffset ? (0,dates/* timeSpanToDays */.ci)(prePopulateData.defaultTicketingStartTimeOffset) : "");
              setUrl(prePopulateData.publicRouteUrL ? prePopulateData.publicRouteUrL : "");
              setShootingLocations(prePopulateData.shootingLocations ? prePopulateData.shootingLocations : null);

              if (prePopulateData.showTemplates) {
                setTemplate(prePopulateData, "FirstEmailTemplate");
                setTemplate(prePopulateData, "ReminderEmailTemplate");
                setTemplate(prePopulateData, "ConfirmEmailTemplate");
                setTemplate(prePopulateData, "GroupEmailTemplate");
                setTemplate(prePopulateData, "TicketEmailTemplate");
                setTemplate(prePopulateData, "ConfirmSmsTemplate");
                setTemplate(prePopulateData, "ReminderSmsTemplate");
              }

              if (!prePopulateData.imageId) {
                _context.next = 23;
                break;
              }

              setLoadingAssets(true);
              _context.next = 18;
              return readImage(prePopulateData.imageId);

            case 18:
              imageResponse = _context.sent;
              _context.next = 21;
              return imageResponse.blob();

            case 21:
              blob = _context.sent;
              setViewModel(function (previousModel) {
                return _objectSpread(_objectSpread({}, previousModel), {}, {
                  image: blob,
                  objectURL: URL.createObjectURL(blob)
                });
              });

            case 23:
              if (!prePopulateData.termsAndConditionsId) {
                _context.next = 34;
                break;
              }

              setLoadingAssets(true);
              _context.next = 27;
              return (0,ShowService/* readTermsAndConditions */.D0)(prePopulateData.termsAndConditionsId);

            case 27:
              termsResponse = _context.sent;
              filename = termsResponse.headers.get("content-disposition").split(";").find(function (n) {
                return n.includes("filename=");
              }).replace("filename=", "").trim();
              _context.next = 31;
              return termsResponse.blob();

            case 31:
              _blob = _context.sent;
              termsFile = new File([_blob], filename, {
                type: _blob.type
              });
              setViewModel(function (previousModel) {
                return _objectSpread(_objectSpread({}, previousModel), {}, {
                  termsAndConditions: termsFile,
                  termsAndConditionsObjURL: URL.createObjectURL(_blob)
                });
              });

            case 34:
              setLoadingAssets(false);

            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function prePopulateForm() {
      return _ref3.apply(this, arguments);
    };
  }();

  var uploadToClient = function uploadToClient(event) {
    if (event.target.files && event.target.files[0]) {
      var image = event.target.files[0];
      var objectURL = URL.createObjectURL(image);
      setViewModel(_objectSpread(_objectSpread({}, viewModel), {}, {
        image: image,
        objectURL: objectURL
      }));
    }
  };

  var uploadTermsToClient = function uploadTermsToClient(event) {
    if (event.target.files && event.target.files[0]) {
      var termsAndConditions = event.target.files[0];

      if (termsAndConditions.type === 'application/pdf') {
        setTermsAndConditionsError(false);
        var termsAndConditionsObjURL = URL.createObjectURL(termsAndConditions);
        setViewModel(_objectSpread(_objectSpread({}, viewModel), {}, {
          termsAndConditions: termsAndConditions,
          termsAndConditionsObjURL: termsAndConditionsObjURL
        }));
      } else {
        setErrorMessage("Please Add a PDF file");
        setSnackbarErrorOpen(true);
        setTermsAndConditionsError(true);
      }
    }
  };

  var removeImage = function removeImage() {
    setViewModel(function (previousModel) {
      return _objectSpread(_objectSpread({}, previousModel), {}, {
        image: null,
        objectURL: null
      });
    });
  };

  var removeTermsAndConditions = function removeTermsAndConditions() {
    setViewModel(function (previousModel) {
      return _objectSpread(_objectSpread({}, previousModel), {}, {
        termsAndConditions: null,
        termsAndConditionsObjURL: null
      });
    });
  };

  var getEditShowWarningMessage = function getEditShowWarningMessage() {
    var editWarningMessage = "Certain changes to show details (such as time, date and location) can have unexpected consequences. Please be careful when editing.";
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContentText/* default */.Z, {
      sx: {
        p: '4px',
        marginBottom: '1.5rem',
        textAlign: 'center',
        borderStyle: 'solid',
        borderColor: 'red',
        borderRadius: '5px',
        fontWeight: 'bold',
        fontSize: '14px'
      },
      children: editWarningMessage
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
      className: (CreateShow_module_default()).createShow,
      open: open,
      onClose: handleDialogClose,
      fullWidth: true,
      maxWidth: "sm",
      "data-cy": "createShowModal",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
        children: dialogTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
        className: (CreateShow_module_default()).content,
        children: [type === 'edit' ? getEditShowWarningMessage() : null, /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
          className: (CreateShow_module_default()).input,
          label: "Show Name",
          required: true,
          error: showNameError,
          helperText: showNameError ? "Show name is mandatory." : "",
          size: "small",
          value: showName,
          onChange: function onChange(event) {
            setShowName(event.target.value);
          },
          onBlurCapture: function onBlurCapture() {
            setShowNameError(showName === "");
          },
          "data-cy": "modal-show-name"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
          className: (CreateShow_module_default()).input,
          label: "Synopsis",
          size: "small",
          multiline: true,
          required: true,
          value: synopsis,
          onChange: function onChange(event) {
            setSynopsis(event.target.value);
          },
          "data-cy": "modal-show-synopsis"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
          className: (CreateShow_module_default()).input,
          label: "Network Name",
          required: true,
          error: networkNameError,
          helperText: networkNameError ? "Network name is mandatory." : "",
          size: "small",
          value: networkName,
          onChange: function onChange(event) {
            setNetworkName(event.target.value);
          },
          onBlurCapture: function onBlurCapture() {
            setNetworkNameError(networkName === "");
          },
          "data-cy": "modal-show-networkName"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
          className: (CreateShow_module_default()).input,
          label: "Production Company",
          required: true,
          error: productionCompanyError,
          helperText: productionCompanyError ? "Production company is mandatory." : "",
          size: "small",
          value: productionCompany,
          onChange: function onChange(event) {
            setProductionCompany(event.target.value);
          },
          onBlurCapture: function onBlurCapture() {
            setProductionCompanyError(productionCompany === "");
          },
          "data-cy": "modal-show-productionCompany"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
          className: (CreateShow_module_default()).input,
          disabled: true,
          label: "Initial Fill Percentage" //required
          ,
          error: initialFillPercentageError,
          helperText: initialFillPercentageError ? "Initial fill percentage is mandatory." : "",
          value: initialFillPercentage,
          size: "small",
          type: "number",
          inputProps: {
            min: 0,
            max: 100
          },
          onChange: function onChange(event) {
            setInitialFillPercentage(event.target.value);
          },
          onBlurCapture: function onBlurCapture() {
            setInitialFillPercentageError(initialFillPercentage === "");
          },
          "data-cy": "modal-show-initialFillPercentage"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          sx: {
            display: "flex",
            gap: "1rem"
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
            className: (CreateShow_module_default()).input,
            label: "Minimum Age Requirement",
            value: minAgeRequirement,
            size: "small",
            sx: {
              label: {
                fontSize: "14px"
              }
            },
            type: "number",
            onChange: function onChange(event) {
              setMinAgeRequirement(event.target.value);
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
            className: (CreateShow_module_default()).input,
            label: "Ticketing Start Time Offset",
            required: true,
            error: ticketingStartTimeOffsetError,
            helperText: ticketingStartTimeOffsetError ? "Ticketing Start Time Offset is mandatory." : "",
            value: ticketingStartTimeOffset,
            size: "small",
            sx: {
              label: {
                fontSize: "14px"
              }
            },
            onChange: function onChange(event) {
              setTicketingStartTimeOffset(event.target.value);
            },
            onBlurCapture: function onBlurCapture() {
              setTicketingStartTimeOffsetError(ticketingStartTimeOffset === "");
            },
            "data-cy": "modal-show-ticketingStartTimeOffset",
            InputProps: {
              endAdornment: /*#__PURE__*/(0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "end",
                children: "days"
              })
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
          className: (CreateShow_module_default()).input,
          label: "Public Route Url",
          required: true,
          error: urlError,
          helperText: urlError ? "Public route urL is mandatory." : "",
          size: "small",
          value: url,
          onChange: function onChange(event) {
            setUrl(event.target.value);
          },
          onBlurCapture: function onBlurCapture() {
            setUrlError(url === "");
          },
          "data-cy": "modal-show-publicRouteUrl"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          sx: {
            display: "flex",
            gap: "1rem"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LocalizationProvider/* LocalizationProvider */._, {
            dateAdapter: AdapterDayjs/* AdapterDayjs */.y,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DesktopDatePicker/* DesktopDatePicker */.$, {
              value: showLaunchDate,
              onChange: function onChange(value) {
                setShowLaunchDate(value);
              },
              className: (CreateShow_module_default()).input,
              label: "Show Launch Date",
              inputFormat: "DD/MM/YYYY",
              disablePast: true,
              renderInput: function renderInput(params) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, _objectSpread(_objectSpread({}, params), {}, {
                  size: "small",
                  "data-cy": "modal-showLaunch-date-input",
                  error: showLaunchDateError,
                  helperText: showLaunchDateError ? "Show Launch Date is mandatory." : "",
                  onBlur: function onBlur() {
                    setShowLaunchDateError(showLaunchDate === null);
                  }
                }));
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TimePicker/* TimePicker */.j, {
              className: (CreateShow_module_default()).input,
              label: "Show Launch Time",
              value: showLaunchTime,
              onChange: function onChange(value) {
                setShowLaunchTime(value);
              },
              renderInput: function renderInput(params) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, _objectSpread(_objectSpread({}, params), {}, {
                  size: "small",
                  "data-cy": "modal-showLaunchTime-input",
                  error: showLaunchTimeError,
                  helperText: showLaunchTimeError ? "Show Launch Time is mandatory." : "",
                  onBlur: function onBlur() {
                    setShowLaunchTimeError(showLaunchTime === null);
                  }
                }));
              }
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShootingLocationInput_ShootingLocationInput, {
          value: shootingLocations,
          error: shootingLocationsError,
          helperText: shootingLocationsError ? "At least one shooting location is mandatory." : "",
          onChange: function onChange(data) {
            setShootingLocations(data);
            setShootingLocationsError(data == null || data.length < 1);
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TemplateInput_TemplateInput, {
          name: ShowTemplateType.FirstEmailTemplate,
          mailType: "BulkEmail",
          templates: templates,
          template: firstEmailTemplate,
          setTemplate: setFirstEmailTemplate,
          templateSubject: firstEmailTemplateSubject,
          setTemplateSubject: setFirstEmailTemplateSubject,
          templateContent: firstEmailTemplateContent,
          setTemplateContent: setFirstEmailTemplateContent,
          emptyContentJson: emptyContentJson
        }, 1), /*#__PURE__*/(0,jsx_runtime.jsx)(TemplateInput_TemplateInput, {
          name: ShowTemplateType.ReminderEmailTemplate,
          mailType: "BulkEmail",
          templates: templates,
          template: reminderEmailTemplate,
          setTemplate: setReminderEmailTemplate,
          templateSubject: reminderEmailTemplateSubject,
          setTemplateSubject: setReminderEmailTemplateSubject,
          templateContent: reminderEmailTemplateContent,
          setTemplateContent: setReminderEmailTemplateContent,
          emptyContentJson: emptyContentJson
        }, 2), /*#__PURE__*/(0,jsx_runtime.jsx)(TemplateInput_TemplateInput, {
          name: ShowTemplateType.ConfirmEmailTemplate,
          mailType: "Email",
          templates: templates,
          template: confirmEmailTemplate,
          setTemplate: setConfirmEmailTemplate,
          templateSubject: confirmEmailTemplateSubject,
          setTemplateSubject: setConfirmEmailTemplateSubject,
          templateContent: confirmEmailTemplateContent,
          setTemplateContent: setConfirmEmailTemplateContent,
          emptyContentJson: emptyContentJson
        }, 3), /*#__PURE__*/(0,jsx_runtime.jsx)(TemplateInput_TemplateInput, {
          name: ShowTemplateType.GroupEmailTemplate,
          mailType: "Email",
          templates: templates,
          template: groupEmailTemplate,
          setTemplate: setGroupEmailTemplate,
          templateSubject: groupEmailTemplateSubject,
          setTemplateSubject: setGroupEmailTemplateSubject,
          templateContent: groupEmailTemplateContent,
          setTemplateContent: setGroupEmailTemplateContent,
          emptyContentJson: emptyContentJson
        }, 4), /*#__PURE__*/(0,jsx_runtime.jsx)(TemplateInput_TemplateInput, {
          name: ShowTemplateType.TicketEmailTemplate,
          mailType: "Email",
          templates: templates,
          template: ticketEmailTemplate,
          setTemplate: setTicketEmailTemplate,
          templateSubject: ticketEmailTemplateSubject,
          setTemplateSubject: setTicketEmailTemplateSubject,
          templateContent: ticketEmailTemplateContent,
          setTemplateContent: setTicketEmailTemplateContent,
          emptyContentJson: emptyContentJson
        }, 5), /*#__PURE__*/(0,jsx_runtime.jsx)(TemplateInput_TemplateInput, {
          name: ShowTemplateType.ConfirmSmsTemplate,
          mailType: "Sms",
          templates: templates,
          template: confirmSmsTemplate,
          setTemplate: setConfirmSmsTemplate,
          templateSubject: confirmSmsTemplateSubject,
          setTemplateSubject: setConfirmSmsTemplateSubject,
          templateContent: confirmSmsTemplateContent,
          setTemplateContent: setConfirmSmsTemplateContent,
          emptyContentJson: emptyContentJson
        }, 6), /*#__PURE__*/(0,jsx_runtime.jsx)(TemplateInput_TemplateInput, {
          name: ShowTemplateType.ReminderSmsTemplate,
          mailType: "Sms",
          templates: templates,
          template: reminderSmsTemplate,
          setTemplate: setReminderSmsTemplate,
          templateSubject: reminderSmsTemplateSubject,
          setTemplateSubject: setReminderSmsTemplateSubject,
          templateContent: reminderSmsTemplateContent,
          setTemplateContent: setReminderSmsTemplateContent,
          emptyContentJson: emptyContentJson
        }, 7), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          container: true,
          spacing: 2,
          justifyContent: "space-between",
          children: loadingAssets ? /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sx: {
              display: "flex",
              minHeight: 150
            },
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              sm: !viewModel.objectURL ? 5 : 12,
              children: [!viewModel.objectURL && /*#__PURE__*/(0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FormLabel/* default */.Z, {
                  htmlFor: "image",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                    id: "image",
                    name: "image",
                    type: "file",
                    accept: "image/jpeg, image/png",
                    hidden: true,
                    onChange: uploadToClient,
                    "data-cy": "modal-show-banner"
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Fab/* default */.Z, {
                    component: "span",
                    size: "small",
                    variant: "extended",
                    sx: {
                      pr: 2
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(esm_Add/* default */.Z, {}), " Add Show Banner"]
                  })]
                })
              }), !!viewModel.objectURL && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (CreateShow_module_default()).imageContainer,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: viewModel.objectURL,
                  layout: "fill",
                  objectFit: "cover",
                  alt: "Show Banner"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                  variant: "contained",
                  onClick: removeImage,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Remove/* default */.Z, {})
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
              item: true,
              sx: {
                display: "flex"
              },
              children: [!viewModel.termsAndConditionsObjURL && /*#__PURE__*/(0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FormLabel/* default */.Z, {
                  htmlFor: "termsAndConditions",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                    id: "termsAndConditions",
                    name: "termsAndConditions",
                    type: "file",
                    accept: ".pdf",
                    hidden: true,
                    onChange: uploadTermsToClient,
                    "data-cy": "modal-show-terms"
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Fab/* default */.Z, {
                    component: "span",
                    size: "small",
                    variant: "extended",
                    sx: {
                      pr: 2,
                      marginBottom: "1.5rem"
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(esm_Add/* default */.Z, {}), "Add Terms and Conditions"]
                  })]
                })
              }), !!viewModel.termsAndConditionsObjURL && /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                  display: "flex",
                  flex: 1,
                  justifyContent: "space-between",
                  alignItems: "center"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                  children: "Terms and Conditions"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
                  sx: {
                    display: "flex",
                    alignItems: "center"
                  },
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    sx: {
                      color: "#1976d2",
                      pr: 5
                    },
                    "data-cy": "modal-show-terms-filename",
                    children: (_viewModel$termsAndCo = viewModel.termsAndConditions) === null || _viewModel$termsAndCo === void 0 ? void 0 : _viewModel$termsAndCo.name
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    size: "small",
                    variant: "contained",
                    onClick: removeTermsAndConditions,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Remove/* default */.Z, {})
                  })]
                })]
              })]
            })]
          })
        }), type === 'edit' ? getEditShowWarningMessage() : null]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          onClick: handleDialogClose,
          "data-cy": "modal-show-cancel",
          children: "Cancel"
        }), loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          className: (CreateShow_module_default()).loadingButton,
          type: "button",
          variant: "contained",
          color: "primary",
          disabled: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          className: (CreateShow_module_default()).loadingButton,
          disabled: submitDisabled,
          variant: "contained",
          onClick: handlePostShow,
          "data-cy": "modal-show-action",
          children: submitMessage
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
      open: snackbarErrorOpen,
      autoHideDuration: 6000,
      onClose: handleClose,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
        onClose: handleClose,
        severity: "error",
        sx: {
          width: "100%"
        },
        children: errorMessage
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
      open: snackbarSuccessOpen,
      autoHideDuration: 6000,
      onClose: handleClose,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
        onClose: handleClose,
        severity: "success",
        sx: {
          width: "100%"
        },
        children: successMessage
      })
    })]
  });
};

/* harmony default export */ var CreateShow_CreateShow = ((0,next_router.withRouter)(CreateShow));
// EXTERNAL MODULE: ./src/models/types.ts
var types = __webpack_require__(53901);
;// CONCATENATED MODULE: ./src/services/TemplateService.tsx




var readTemplates = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var fetchUrl, res, resJson, message;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            fetchUrl = "/api/backend/templates";
            _context.next = 4;
            return (0,auth/* fetchWithAuth */.ri)(fetchUrl, {
              headers: {
                "Content-Type": "application/json"
              }
            });

          case 4:
            res = _context.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context.next = 7;
              break;
            }

            throw new Error("Server not returned a valid response");

          case 7:
            _context.next = 9;
            return res.json();

          case 9:
            resJson = _context.sent;
            return _context.abrupt("return", new types/* TemplatesResponse */.F$({
              data: resJson.templates
            }));

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](0);

            if (_context.t0 instanceof Error) {
              message = _context.t0.message;
            } else {
              message = "Unable to load ticket";
            }

            return _context.abrupt("return", new types/* TemplatesResponse */.F$({
              error: message
            }));

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 13]]);
  }));

  return function readTemplates() {
    return _ref.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./src/services/NotificationService.tsx



var sendTestEmail = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(showId, showTemplateType) {
    var body, res, resText;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            body = JSON.stringify({
              showId: showId,
              showTemplateType: showTemplateType
            });
            _context.next = 4;
            return (0,auth/* fetchWithAuth */.ri)("/api/backend/notification/test-email", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: body
            });

          case 4:
            res = _context.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context.next = 10;
              break;
            }

            _context.next = 8;
            return res.json();

          case 8:
            resText = _context.sent;
            return _context.abrupt("return", resText);

          case 10:
            return _context.abrupt("return", res);

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              error: _context.t0
            });

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 13]]);
  }));

  return function sendTestEmail(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./src/icons/index.ts
var icons = __webpack_require__(46409);
;// CONCATENATED MODULE: ./src/pages/Show/Show.tsx






function Show_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Show_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Show_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Show_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




























var Show_Show = function Show(_ref) {
  var _viewModel$showRespon;

  var dashboards = _ref.dashboards,
      companyHealthScore = _ref.companyHealthScore;

  var _useState = (0,react.useState)("create"),
      editType = _useState[0],
      setEditType = _useState[1];

  var _useState2 = (0,react.useState)(),
      prePopulateShowData = _useState2[0],
      setPrePopulateShowData = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      deleteShowDialogOpen = _useState3[0],
      setDeleteShowDialogOpen = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      snackbarSuccessOpen = _useState4[0],
      setSnackbarSuccessOpen = _useState4[1];

  var _useState5 = (0,react.useState)(""),
      snackbarMessage = _useState5[0],
      setSnackbarMessage = _useState5[1];

  var _useState6 = (0,react.useState)(0),
      showId = _useState6[0],
      setShowId = _useState6[1];

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      testEmailDialog = _React$useState2[0],
      setTestEmailDialog = _React$useState2[1];

  var _React$useState3 = react.useState(""),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      testEmailTemplate = _React$useState4[0],
      setTestEmailTemplate = _React$useState4[1];

  var _React$useState5 = react.useState(),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      templates = _React$useState6[0],
      setTemplates = _React$useState6[1];

  var today = dayjs_min_default()(new Date());

  var ListShowsViewModel = /*#__PURE__*/(0,createClass/* default */.Z)(function ListShowsViewModel(_ref2) {
    var showResponse = _ref2.showResponse,
        loading = _ref2.loading;

    (0,classCallCheck/* default */.Z)(this, ListShowsViewModel);

    (0,defineProperty/* default */.Z)(this, "showResponse", void 0);

    (0,defineProperty/* default */.Z)(this, "loading", void 0);

    this.showResponse = showResponse || null;
    this.loading = loading || null;
  });

  var _useState7 = (0,react.useState)(new ListShowsViewModel({})),
      viewModel = _useState7[0],
      setViewModel = _useState7[1];

  var router = (0,next_router.useRouter)();
  var columns = [{
    field: "name",
    headerName: "Name",
    flex: 2,
    maxWidth: 300,
    minWidth: 100
  }, {
    field: "audienceLink",
    headerName: "Audience Link",
    flex: 1,
    maxWidth: 200,
    minWidth: 120,
    sortable: false,
    renderCell: function renderCell(params) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/audience/".concat(params.row.publicRouteUrL),
        target: "_blank",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          sx: {
            px: "0"
          },
          children: "To Audience View"
        })
      });
    }
  }, {
    field: "termsAndConditionsLink",
    headerName: "Terms and Conditions",
    flex: 1,
    maxWidth: 230,
    minWidth: 100,
    sortable: false,
    renderCell: function renderCell(params) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: params.row.termsAndConditionsId ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/api/backend/termsandconditions?id=".concat(params.row.termsAndConditionsId),
          target: "_blank",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            sx: {
              px: "16px"
            },
            children: "Terms and Conditions"
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          variant: "caption",
          sx: {
            px: "0"
          },
          children: "No Terms and Conditions"
        })
      });
    }
  }, {
    field: "healthscore",
    headerName: "Health Score",
    description: "The show health score represents the average of the sessions health score",
    sortable: false,
    minWidth: 100,
    flex: 1,
    renderCell: function renderCell(params) {
      var _dashboards$params$ro;

      return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
          px: "0",
          width: 160
        },
        "data-cy": "show-healthscore",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(HealthScoreBar/* default */.Z, {
          score: dashboards === null || dashboards === void 0 ? void 0 : (_dashboards$params$ro = dashboards[params.row.id]) === null || _dashboards$params$ro === void 0 ? void 0 : _dashboards$params$ro.showHealthScore
        })
      });
    }
  }, {
    field: "goToScannerList",
    headerName: "",
    maxWidth: 50,
    sortable: false,
    renderCell: function renderCell(params) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        title: "Show QR code scanner list",
        placement: "top",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/scan/".concat(params.row.scanId),
          target: "_blank",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* Icon */.J, {
              icon: "Qrcode",
              "data-cy": "scannerListIcon"
            })
          })
        })
      });
    }
  }, {
    field: "goToAllocations",
    headerName: "",
    maxWidth: 50,
    sortable: false,
    renderCell: function renderCell() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
          title: "Show allocations",
          placement: "top",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReduceCapacity/* default */.Z, {
            "data-cy": "allocationsIcon",
            className: classnames_default()((Show_module_default()).editIcon, "allocationsIcon")
          })
        })
      });
    }
  }, {
    field: "goToAllocationsV2",
    headerName: "",
    maxWidth: 50,
    sortable: false,
    renderCell: function renderCell(params) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
          title: "Show allocations V2",
          placement: "top",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/allocations-v2/".concat(params.row.publicRouteUrL, "/table"),
            target: "_blank",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* Icon */.J, {
                icon: "UserGroup",
                "data-cy": "allocationsV2Icon"
              })
            })
          })
        })
      });
    }
  }, {
    field: "sendEmail",
    headerName: "",
    maxWidth: 50,
    sortable: false,
    renderCell: function renderCell() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
          title: "Send test email",
          placement: "top",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Email/* default */.Z, {
            "data-cy": "showsEmailIcon",
            className: classnames_default()((Show_module_default()).editIcon, "emailShowIcon")
          })
        })
      });
    }
  }, {
    field: "edit",
    headerName: "",
    maxWidth: 50,
    sortable: false,
    renderCell: function renderCell() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
          title: "Edit show",
          placement: "top",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Edit/* default */.Z, {
            "data-cy": "showsEditIcon",
            className: classnames_default()((Show_module_default()).editIcon, "editShowIcon")
          })
        })
      });
    }
  }, {
    field: "delete",
    headerName: "",
    maxWidth: 50,
    align: "center",
    sortable: false,
    renderCell: function renderCell(params) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        disabled: !params.row.isDeletable,
        "data-cy": "delete-show-button",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
          title: "Delete show",
          placement: "top",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Delete/* default */.Z, {
            "data-cy": "deleteIcon",
            className: (Show_module_default()).deleteIcon
          })
        })
      });
    }
  }];

  var fetchTemplates = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _yield$readTemplates, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return readTemplates();

            case 2:
              _yield$readTemplates = _context.sent;
              data = _yield$readTemplates.data;

              if (data) {
                setTemplates(data);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchTemplates() {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    fetchTemplates();

    try {
      setViewModel(Show_objectSpread(Show_objectSpread({}, viewModel), {}, {
        loading: true
      }));
      (0,ShowService/* readShows */.$S)().then(function (showResponse) {
        setViewModel({
          showResponse: showResponse,
          loading: false
        });
      });
    } catch (error) {
      if (error) {
        setViewModel({
          showResponse: null,
          loading: false
        });
      }
    }
  }, []);

  var handleSendTestEmail = function handleSendTestEmail(values) {
    sendTestEmail(showId, testEmailTemplate).then(function () {
      setTestEmailDialog(false);
    });
  };

  var activateCreateModal = function activateCreateModal() {
    setPrePopulateShowData(undefined);
    setEditType("create");
    router.push("/?create-show", undefined, {
      shallow: true,
      scroll: false
    });
  };

  var editCreateModal = function editCreateModal(data) {
    setEditType("edit");
    router.push("/?edit-show/".concat(data.id), undefined, {
      shallow: true,
      scroll: false
    });
  };

  var emptyShows = [];

  var handleCellClick = function handleCellClick(params, event, details) {
    if (params.field === "edit") {
      setPrePopulateShowData(params.row);
      sessionStorage.setItem("prepopulateData", JSON.stringify(params.row));
      setShowId(params.row.id);
      editCreateModal(params);
    } else if (params.field === "delete" && params.row.isDeletable) {
      setShowId(params.row.id);
      setDeleteShowDialogOpen(true);
    } else if (params.field === "name" || params.field === "healthscore") {
      router.push("/show/".concat(params.row.id));
    } else if (params.field === "sendEmail") {
      setShowId(params.row.id);
      setTestEmailDialog(true);
    } else if (params.field === "goToAllocations") {
      router.push("/allocations/".concat(params.row.publicRouteUrL));
    }
  };

  var handleDialogClose = function handleDialogClose() {
    setDeleteShowDialogOpen(false);
    router.replace("/", undefined, {
      shallow: true
    });
  };

  var handleDeleteShow = function handleDeleteShow() {
    (0,ShowService/* deleteShow */.N9)(showId).then(function (res) {
      setSnackbarSuccessOpen(true);
      setSnackbarMessage("Show Successfully Deleted!");
      router.push("/", undefined, {
        shallow: true,
        scroll: false
      });
      setDeleteShowDialogOpen(false);
      reloadShows();
    });
  };

  var reloadShows = function reloadShows() {
    (0,ShowService/* readShows */.$S)().then(function (showResponse) {
      setViewModel(function (prev) {
        return Show_objectSpread(Show_objectSpread({}, prev), {}, {
          showResponse: showResponse
        });
      });
    });
  };

  var handleSnackbarClose = function handleSnackbarClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarSuccessOpen(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Page/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Show_module_default()).show,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "h3",
        component: "h1",
        gutterBottom: true,
        align: "center",
        children: "That's The Ticket"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Show_module_default()).table,
        "data-cy": "showsDataGrid",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Show_module_default()).tableHeader,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "h5",
            gutterBottom: true,
            children: "Show list"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
            variant: "outlined",
            onClick: function onClick(event) {
              return activateCreateModal();
            },
            "data-cy": "add-show-button",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Add/* default */.Z, {}), "Add new show"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DataGrid/* DataGrid */._, {
          getRowId: function getRowId(row) {
            return row.name;
          },
          rows: ((_viewModel$showRespon = viewModel.showResponse) === null || _viewModel$showRespon === void 0 ? void 0 : _viewModel$showRespon.data) || emptyShows,
          rowHeight: 43,
          columns: columns,
          pageSize: 5,
          rowsPerPageOptions: [5],
          rowCount: 10,
          autoHeight: true,
          paginationMode: "server",
          loading: viewModel.loading || false,
          getRowClassName: function getRowClassName(item) {
            return today.diff(item.row.createAt, "d") < 3 ? (Show_module_default()).highlightedTableRow : (Show_module_default()).tableRow;
          },
          components: {
            Toolbar: ShowsCustomTableToolbar_ShowsCustomTableToolbar
          },
          componentsProps: {
            toolbar: {
              companyHealthScore: companyHealthScore
            }
          },
          onCellClick: handleCellClick,
          sx: {
            "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
              display: "none"
            }
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CreateShow_CreateShow, {
          showId: showId,
          onSuccess: function onSuccess() {
            return reloadShows();
          },
          type: editType,
          templates: templates
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
          open: testEmailDialog,
          onClose: function onClose() {
            return setTestEmailDialog(false);
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
            children: "Send a Test Email"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DialogContentText/* default */.Z, {
              children: "Send a Test Email for this show on your email address. Select the template defined below."
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
              fullWidth: true,
              style: {
                marginTop: 5
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                children: "Select Template"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* default */.Z, {
                value: testEmailTemplate,
                label: "Select Template",
                onChange: function onChange(event) {
                  setTestEmailTemplate(event.target.value);
                },
                children: Object.entries(ShowTemplateType).map(function (value, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                    value: value[0],
                    children: ShowTemplateTypeNames[value[1]]
                  }, index);
                })
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              onClick: handleSendTestEmail,
              children: "Send"
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        className: (Show_module_default()).attendanceInfo,
        open: deleteShowDialogOpen,
        onClose: handleDialogClose,
        fullWidth: true,
        maxWidth: "xs",
        "data-cy": "deleteShowModal",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
          className: (Show_module_default()).title,
          children: "Delete Show"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
          className: (Show_module_default()).content,
          children: "Are you sure you want to delete this show?"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
          className: (Show_module_default()).actions,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "contained",
            onClick: function onClick() {
              return handleDialogClose();
            },
            "data-cy": "show-close-btn",
            children: "Close"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "contained",
            color: "error",
            onClick: function onClick() {
              return handleDeleteShow();
            },
            "data-cy": "show-delete-btn",
            children: "Delete"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
        open: snackbarSuccessOpen,
        autoHideDuration: 6000,
        onClose: handleSnackbarClose,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
          onClose: handleSnackbarClose,
          severity: "success",
          sx: {
            width: "100%"
          },
          children: snackbarMessage
        })
      })]
    })
  });
};

/* harmony default export */ var pages_Show_Show = ((0,next_router.withRouter)(Show_Show));

/***/ }),

/***/ 2892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ setGeocoderInfo; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50029);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);


var geocoder;
var setGeocoderInfo = /*#__PURE__*/function () {
  var _ref = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(placeType, location) {
    var geocoderResponse, _addr$find, _addr$find2, _addr$find3, _addr$find4, _addr$find5, _addr$find6, _addr$find7, _addr$find8, info, addr, neighborhood, sublocality, locality;

    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!geocoder) {
              geocoder = new google.maps.Geocoder();
            } // const geocoder = { current: null };


            if (!(placeType == null || location == null)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            if (geocoder) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            _context.next = 7;
            return geocoder.geocode({
              placeId: placeType.place_id
            });

          case 7:
            geocoderResponse = _context.sent;

            if (geocoderResponse && geocoderResponse.results && geocoderResponse.results.length > 0) {
              info = geocoderResponse.results[0];
              location.placeId = info.place_id;
              location.latitude = info.geometry.location.lat();
              location.longitude = info.geometry.location.lng();
              location.longLocation = info.formatted_address;
              location.shortLocation = "";
              location.detailsJson = "";
              addr = info.address_components;
              neighborhood = ((_addr$find = addr.find(function (a) {
                return a.types.includes('neighborhood');
              })) === null || _addr$find === void 0 ? void 0 : _addr$find.long_name) || "";
              sublocality = ((_addr$find2 = addr.find(function (a) {
                return a.types.includes('sublocality');
              })) === null || _addr$find2 === void 0 ? void 0 : _addr$find2.long_name) || "";
              locality = ((_addr$find3 = addr.find(function (a) {
                return a.types.includes('locality');
              })) === null || _addr$find3 === void 0 ? void 0 : _addr$find3.long_name) || "";
              location.country = ((_addr$find4 = addr.find(function (a) {
                return a.types.includes('country');
              })) === null || _addr$find4 === void 0 ? void 0 : _addr$find4.long_name) || "";
              location.unitOrApartmentNumber = ((_addr$find5 = addr.find(function (a) {
                return a.types.includes('street_number');
              })) === null || _addr$find5 === void 0 ? void 0 : _addr$find5.long_name) || "";
              location.street = ((_addr$find6 = addr.find(function (a) {
                return a.types.includes('route');
              })) === null || _addr$find6 === void 0 ? void 0 : _addr$find6.long_name) || "";
              location.suburb = neighborhood || sublocality || locality || "";
              location.state = ((_addr$find7 = addr.find(function (a) {
                return a.types.includes('administrative_area_level_1');
              })) === null || _addr$find7 === void 0 ? void 0 : _addr$find7.long_name) || "";
              location.postCode = ((_addr$find8 = addr.find(function (a) {
                return a.types.includes('postal_code');
              })) === null || _addr$find8 === void 0 ? void 0 : _addr$find8.long_name) || "";
            }

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function setGeocoderInfo(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 38213:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"createShow":"CreateShow_createShow__0MjZt","content":"CreateShow_content__Zgp1s","input":"CreateShow_input__k02MP","divider":"CreateShow_divider___zR4f","imageContainer":"CreateShow_imageContainer__qzL7A","loadingButton":"CreateShow_loadingButton__k0Qq3","createShowActions":"CreateShow_createShowActions___QIwD"};

/***/ }),

/***/ 50508:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"ShootingLocationInput_input__2y3qr"};

/***/ }),

/***/ 95002:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"TemplateInput_input__YywFB"};

/***/ }),

/***/ 62185:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"show":"Show_show__YSuT8","tableHeader":"Show_tableHeader__KnFyq","table":"Show_table__5dIV7","tableRow":"Show_tableRow__ARLNO","highlightedTableRow":"Show_highlightedTableRow__FdeJj","editIcon":"Show_editIcon__Evbyu","disabled":"Show_disabled__dfxwV"};

/***/ })

}]);